import { RestSlice } from '../../../../redux/rest.slice';
import { Violation } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const violationSlice = new RestSlice<Violation>(
	localizationService.getLocalizedString('screen.labels.violations'),
	Resource.Violations
);
export const violationsReducer = violationSlice.rests.reducer;
